import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/**
 * Toaster component - centralized toast configuration
 */
export const Toaster: React.FC = () => {
  return (
    <ToastContainer
      position='top-right'
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      pauseOnHover
      theme='light'
    />
  );
};
